"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Checkbox = require("../../components/Checkbox");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Checkbox = {
  styles: function styles(theme) {
    return {
      labelText: {
        color: theme.colors.baseContrast085
      },
      svg: {
        borderRadius: 4,
        borderWidth: 1,
        borderColor: _Checkbox.checkboxVars.get("checkboxPrimary", theme.colors.baseContrast060),
        strokeWidth: 3,
        padding: 3
      },
      hint: {
        marginInlineStart: theme.spacing.base / 2,
        textTransform: "initial",
        color: theme.colors.baseContrast085
      },
      description: {
        textTransform: "initial",
        color: theme.colors.baseContrast085
      }
    };
  }
};
var _default = exports.default = Checkbox;